<script>
    import {Link} from './router';
    import app from './stores/app';
    import app_alert from "./stores/alerts";
    import success from './stores/success';
    import {router} from './router/Router.svelte';
    import {getClientList, clientDelete} from "./requests";
    import TableHeader from './controls/TableHeader.svelte';
    import ClientRow from './ClientRow.svelte';

    let table_columns = [
        {key: 'lastname', name: 'Όνομα', sortable: true, sort_way: 'ASC', align: ''},
        {key: 'username', name: 'Λογαριασμός', sortable: true, sort_way: '', align: ''},
        {key: 'email', name: 'Email', sortable: true, sort_way: '', align: ''},
        {key: 'originator', name: 'Αποστολέας', sortable: true, sort_way: '', align: ''},
        {key: 'provider', name: 'Provider', sortable: true, sort_way: '', align: ''},
        {key: 'credits', name: 'Μονάδες', sortable: true, sort_way: '', align: ''},
        {key: 'last_sent', name: 'Τελ. αποστολή', sortable: true, sort_way: '', align: ''},
        {key: 'last_login', name: 'Είσοδος', sortable: true, sort_way: '', align: ''},
        {key: '', name: '', sortable: false, sort_way: '', align: ''},
    ]

    let clientList = [];
    let totalClients = null;
    let totalPages = null;
    let search = {
        name: "",
        username: "",
        email: "",
        sort_key: 'lastname',
        sort_way: 'ASC',
    }

    const close = () => {
        router._go("/app");
    }

    const onSort = ({detail:column}) => {
        search.sort_key = column.key;
        search.sort_way = column.sort_way;
        loadClients();
    }

    export const loadClients = async () => {
        const [err, res] = await getClientList(search);

        if (err) {
            return;
        }

        clientList = res.list;
        totalClients = res.total;
    }

    const onSearchKeyUp = event => {
        if (event.key === 'Enter') {
            loadClients();
        }
    }

    const clearSearch = () => {
        search.name = "";
        search.username = "";
        search.email = "";
    }

    const evtDeleteClient = ({detail}) => {
        app_alert.show('confirm', 'Θέλετε διαγράψετε τον πελάτη "' + detail.name + '";', function () {
            doDeleteClient(detail.id);
        });
    }

    const doDeleteClient = async (id) => {
        const [err, res] = await clientDelete(id);

        if (err) {
            return;
        }

        success.show("Ο πελάτης διαγράφτηκε.");

        loadClients();
    }

    loadClients();

    $: {
        if ($app.clientChanged) {
            app.clientChange(false);
            loadClients();
        }
    }
</script>

<div class="page-header">
    <div class="page-title">Πελάτες</div>
    <div class="controls">
        <div title="Ανανέωση λίστας" on:click|preventDefault="{ loadClients }">
            <span class="icon"><i class="fa fa-refresh"></i></span>
            <span class="caption">Ανανέωση</span>
        </div>
        <div title="Κλείσιμο" on:click|preventDefault="{ close }">
            <span class="icon"><i class="fa fa-times"></i></span>
        </div>
    </div>
</div>

<div class="page">
    <div class="page-main">

        <div class="panel">
            <div class="panel-heading">
                ΑΝΑΖΗΤΗΣΗ
            </div>
            <div class="panel-body">
                <div class="row">
                    <div class="col-md-2 col-xs-6">
                        <div class="form-group">
                            <label>ΟΝΟΜΑ</label>
                            <input type="text" bind:value="{ search.name }" class="form-control" on:keyup="{ onSearchKeyUp }">
                        </div>
                    </div>
                    <div class="col-md-2 col-xs-6">
                        <div class="form-group">
                            <label>ΟΝΟΜΑ ΧΡΗΣΤΗ</label>
                            <input type="text" bind:value="{ search.username }" class="form-control" on:keyup="{ onSearchKeyUp }">
                        </div>
                    </div>
                    <div class="col-md-2 col-xs-6">
                        <div class="form-group">
                            <label>EMAIL</label>
                            <input type="text" bind:value="{ search.email }" class="form-control" on:keyup="{ onSearchKeyUp }">
                        </div>
                    </div>

                    <div class="col-md-6 col-xs-12 text-right">
                        <div class="label-spacer"></div>
                        <button class="btn btn-primary block-for-xs" on:click="{ loadClients }">ΕΥΡΕΣΗ</button>
                        <button class="btn btn-default block-for-xs mrg-b-none" on:click="{ clearSearch }">ΚΑΘΑΡΙΣΜΟΣ
                        </button>
                    </div>
                </div>

            </div>
        </div> <!-- /search -->

        <div class="panel">
            <div class="panel-heading">
                ΠΕΛΑΤΕΣ
                {#if (totalClients > 0)}
                    <span class="total">({ totalClients })</span>
                {/if}
                <div class="controls-right">
                    <span on:click="{ () => app.editClient(0) }" title="Δημιουργία νέου πελάτη"><i
                            class="fa fa-plus"></i></span>
                </div>
            </div>
            {#if clientList.length}
                <div class="table-responsive">
                    <table class="table table-bordered table-list table-data mrg-b-none">
                        <TableHeader table_columns="{ table_columns }" on:sort="{ onSort }"/>
                        <tbody>
                        {#each clientList as client}
                            <ClientRow client="{ client }" on:delete="{ evtDeleteClient }"/>
                        {/each}
                        </tbody>
                    </table>
                </div>
            {:else}
                <div class="panel-body">
                    <p>Δεν βρέθηκαν πελάτες με αυτά τα κριτήρια αναζήτησης.</p>
                </div>
            {/if}
        </div>
    </div> <!-- /page-main -->
</div>
